<div class="form-row" [formGroup]="form">
  <div class="col-lg-6 col-md-6 mr-1">
    <div class="wrap-flex form-outline">
      <div ngbDropdown>
        <div class="flex flex-column">
          <label class="mb-0">{{ ('TR_SELECT_ANSWER_TYPE_SENSITIVITY' | translate) + mainService.asterisk }}</label>
          <button type="button" ngbDropdownToggle class="mb-2 btn btn-outline-info">
            {{ (selectedAnswerCaseType | translate) || selectedAnswerCaseType }}
          </button>
        </div>
        <div ngbDropdownMenu>
          <button type="button" class="dropdown-item" *ngFor="let item of answerCaseTypes; index as i" (click)="setSelectedAnswerCaseType(i, item)">
            {{ item | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-md-8 mr-1" formArrayName="answers">
    <div [formGroupName]="i" class="answer-block mb-2" *ngFor="let answer of form.get('answers')['controls']; let i=index">
      <div class="form-row">
        <div class="col-12">
          <div class="position-relative form-group">
            <label for="text">{{ ('TR_TEXT' | translate) + mainService.asterisk }}</label>
            <input
              name="text"
              [placeholder]="('TR_TEXT' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              autocomplete="off"
              formControlName="text"
            />
          </div>
        </div>
      </div>
      <div class="flex-wrap form-outline form-group mt-0 ">
        <div class="flex flex-column">
          <div ngbDropdown>
            <div class="flex flex-column">
              <label>{{ ('TR_GRADE' | translate) + mainService.asterisk }}</label>
              <button
                ngbDropdownToggle
                type="button"
                class="mb-2 mr-2 btn btn-outline-info white-background"
              >
                {{
                  form.value.answers[i].gradepercent || form.value.answers[i].gradepercent === 0
                    ? form.value.answers[i].gradepercent === 0
                      ? ('TR_NONE' | translate) : (form.value.answers[i].gradepercent + '%')
                    : ('TR_GRADE' | translate) + mainService.asterisk
                }}
              </button>
            </div>
            <div ngbDropdownMenu>
              <button type="button" class="dropdown-item" *ngFor="let item of grades" (click)="setSelectedGrade(item, i)">
                {{ item === 0 ? ('TR_NONE' | translate) : (item + '%') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-12">
          <div class="position-relative form-group">
            <label for="feedback">{{ 'TR_FEEDBACK' | translate }}</label>
            <textarea
              name="feedback"
              [placeholder]="'TR_FEEDBACK' | translate"
              type="text"
              class="form-control"
              autocomplete="off"
              formControlName="feedback"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="mb-2 btn-transition btn btn-outline-info create-btn" (click)="addAnswer()">
      <i class="fa fa-plus"></i><span class="ml-2">{{ 'TR_ADD_ANSWER' | translate }}</span>
    </button>
  </div>
</div>